// packages/web/src/hooks/useOnline.ts
import { useEffect, useState } from 'react';

/**
 * Reactive boolean: true when the browser reports network connectivity.
 * SSR-safe: returns true when `navigator` is unavailable.
 */
export function useOnline(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(() => {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine;
  });

  useEffect(() => {
    const onOnline = (): void => {
      setIsOnline(true);
    };
    const onOffline = (): void => {
      setIsOnline(false);
    };
    setIsOnline(navigator.onLine);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return (): void => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return isOnline;
}
